module.exports = __webpack_public_path__ + "img/logo-aoqan-icon.498e2069.svg";